<template>
    <div class="modal fade" id="costumModalpeta" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog modal-fullscreen" style="width: 98vw;height: 90%;">
            <div class="modal-content" style="height: auto;min-width: 95vw; min-height: 90%;">
                <div class="modal-header">
                    <h4 class="modal-title">Pengaturan Perserta Pelatihan</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-justify" style="height: auto;min-width: 95vw; min-height: 90%;">
                    <p>
                    <div class="row">
                        <div class="col-sm-12 text-center">
                            <a class="hitam">
                                <button type="button" class="btn btn-success btn-sm text-white lebar2"
                                    data-toggle="tooltip" data-placement="left" title="Unduh master excel.."
                                    @click="G_tableCSV('_TemplateAbsensi_')">
                                    <i class="fas fa-download"></i> Unduh Master Template Peserta Pelatihan .xlsx
                                </button>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Pilih File<small class="text-info"> (*.xlsx)</small>
                                </label>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text"><i class="far fa-file-image"></i></span>
                                    </div>
                                    <input type="file" class="form-control form-control-sm"
                                        id="fileToUploadfilenya_excel" name="fileToUploadfilenya_excel"
                                        placeholder="fileToUpload" style="font-size: smaller;"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        @change="onChange">
                                    <input type="hidden" class="form-control form-control-sm" id="filenya_excel"
                                        name="filenya_excel" placeholder="File Excel">
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <label>Opsi</label>
                                <div class="row">
                                    <div class="col-sm-10">
                                        <div class="progress">
                                            <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                id="persennyafilenya_excel">
                                                <span id="tulisanpersenfilenya_excel">0%</span>
                                            </div>
                                        </div>
                                        <br>
                                        <span class="text-success" id="suksesnyafilenya_excel"></span>
                                    </div>
                                    <div class="col-sm-2 text-center" v-if="tempjumlah > 0">
                                        <button type="button" class="btn btn-warning btn-sm lebar text-white"
                                            @click="uploadsavedata()">
                                            Simpan ke DB
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!--IKON PETA 1 END-->
                            <div class="col-sm-12">
                                Jumlah Data excel siap Import: {{ tempjumlah }}
                                <span style="float: right;">Jumlah Data excel Tersimpan di DB: {{
                                    tempjumlahdb
                                }}</span>
                                <div class="table-responsive table-wrapper" v-if="tempjumlah > 0">
                                    <table class="table m-0" id="tabeldata2">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Urut
                                                </th>
                                                <template v-for="(dataheader, urutheader) in tempheader"
                                                    :key="urutheader">
                                                    <th>
                                                        {{ dataheader }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <template v-for="(datadata, urutdata) in tempdata" :key="urutdata">
                                            <tr>
                                                <td>{{ urutdata + 1 }}</td>
                                                <td v-for="(isidata, urutisi) in datadata" :key="urutisi">
                                                    {{ isidata }}
                                                </td>
                                            </tr>
                                        </template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="row p-3">
                            <div class="col-sm-12">
                                <div class="table-responsive table-wrapper">
                                    <table class="table m-0" id="tabeldata" style="font-size: small;">
                                        <thead>
                                            <tr>
                                                <th style="width: 50px;">Rapat ke-</th>
                                                <th style="width: 200px;">Nama Peserta</th>
                                                <th style="width: 150px;">Jenis Kelamin</th>
                                                <th style="width: 150px;">Email</th>
                                                <th style="width: 150px;">Instansi
                                                </th>
                                                <th style="width: 150px;">Nomor Telp</th>
                                                <th style="width: 150px;">Pengetahuan Meningkat</th>
                                                <th style="width: 150px;">Skor Pre Tes</th>
                                                <th style="width: 150px;">Skor Post Tes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(Pesertasetuju, counterPeserta) in Peserta"
                                                v-bind:key="counterPeserta">
                                                <td class="text-center">
                                                    {{ counterPeserta + 1 }}
                                                    <div class="col-sm-12 text-center">
                                                        <button type="button" class="btn btn-success btn-sm"
                                                            @click="addPeserta"><i
                                                                class="far fa-plus-square"></i></button>
                                                        <button type="button" class="btn btn-warning btn-sm"
                                                            @click="deletePeserta(counterPeserta)"
                                                            v-if="(counterPeserta > 0)"><i
                                                                class="far fa-minus-square"></i>
                                                        </button>
                                                    </div>
                                                    <input type="hidden" class="form-control form-control-sm"
                                                        :id="'kodeunixpeserta' + (counterPeserta + 1)"
                                                        :name="'kodeunixpeserta' + (counterPeserta + 1)"
                                                        placeholder="Tanggal Rapat" :value="Pesertasetuju.kodeunix"
                                                        style="width: 150px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'namapeserta' + (counterPeserta + 1)"
                                                        :name="'namapeserta' + (counterPeserta + 1)"
                                                        placeholder="Nama Peserta" :value="Pesertasetuju.nama"
                                                        style="width: 210px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'jenis_kelamin' + (counterPeserta + 1)"
                                                        :name="'jenis_kelamin' + (counterPeserta + 1)"
                                                        placeholder="Jenis Kelamin" :value="Pesertasetuju.jenis_kelamin"
                                                        style="width: 100px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'email' + (counterPeserta + 1)"
                                                        :name="'email' + (counterPeserta + 1)"
                                                        placeholder="Email" :value="Pesertasetuju.email"
                                                        style="width: 100px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'instansi' + (counterPeserta + 1)"
                                                        :name="'instansi' + (counterPeserta + 1)"
                                                        placeholder="Instansi" :value="Pesertasetuju.instansi"
                                                        style="width: 100px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'telp' + (counterPeserta + 1)"
                                                        :name="'telp' + (counterPeserta + 1)"
                                                        placeholder="telp" :value="Pesertasetuju.telp"
                                                        style="width: 50px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="text" class="form-control form-control-sm"
                                                        :id="'meningkat' + (counterPeserta + 1)"
                                                        :name="'meningkat' + (counterPeserta + 1)"
                                                        placeholder="Pengetahuan Meningkat" :value="Pesertasetuju.meningkat"
                                                        style="width: 50px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="number" class="form-control form-control-sm"
                                                        :id="'pre_test' + (counterPeserta + 1)"
                                                        :name="'pre_test' + (counterPeserta + 1)"
                                                        placeholder="pre_test" :value="Pesertasetuju.pre_test"
                                                        style="width: 50px !important;">
                                                </td>
                                                <td class="text-center">
                                                    <input type="number" class="form-control form-control-sm"
                                                        :id="'post_test' + (counterPeserta + 1)"
                                                        :name="'post_test' + (counterPeserta + 1)"
                                                        placeholder="post_test" :value="Pesertasetuju.post_test"
                                                        style="width: 50px !important;">
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">&nbsp;</div>
                    </p>
                </div>
                <div class="modal-footer text-center">
                    <div class="col-sm-12 text-center">
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" data-dismiss="modal"> <i
                                class="far fa-times-circle"></i>
                            Tutup</button>
                    </div>
                </div>
                <div class="col-sm-12">&nbsp;</div>
                <div class="col-sm-12">&nbsp;</div>
                <div class="col-sm-12">&nbsp;</div>
                <div class="col-sm-12">&nbsp;</div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Monev">Monitoring Evaluasi</a></li>
                                <li class="breadcrumb-item active">Pengaturan KPI 11</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Daftar KPI 11</h3>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row p-3">
                                        <div class="col-sm-12">
                                            Paket Pekerjaan: {{ Nama_Kegiatan }}
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="card direct-chat direct-chat-primary">
                                            <div class="card-header ui-sortable-handle">
                                                <h3 class="card-title">Pelatihan</h3>
                                            </div>
                                            <div class="body">
                                                <div class="row p-3">
                                                    <div class="col-sm-12">
                                                        <div class="table-responsive table-wrapper">
                                                            <table class="table m-0" id="tabeldata"
                                                                style="font-size: small;">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="width: 50px;">Rapat ke-</th>
                                                                        <th style="width: 10px;">Tanggal</th>
                                                                        <th style="width: 200px;">Nama Kegiatan<br>dan
                                                                            Lokasi</th>
                                                                        <th style="width: 150px;">Undangan</th>
                                                                        <th style="width: 150px;">Notulensi</th>
                                                                        <th style="width: 150px;">Dokumentasi
                                                                        </th>
                                                                        <th style="width: 150px;">Absensi</th>
                                                                        <th style="width: 150px;">Peserta</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(Pelatihansetuju, counterPelatihan) in Pelatihan"
                                                                        v-bind:key="counterPelatihan">
                                                                        <td class="text-center">
                                                                            {{ counterPelatihan + 1 }}
                                                                            <div class="col-sm-12 text-center">
                                                                                <button type="button"
                                                                                    class="btn btn-success btn-sm"
                                                                                    @click="addPelatihan"><i
                                                                                        class="far fa-plus-square"></i></button>
                                                                                <button type="button"
                                                                                    class="btn btn-warning btn-sm"
                                                                                    @click="deletePelatihan(counterPelatihan)"
                                                                                    v-if="(counterPelatihan > 0)"><i
                                                                                        class="far fa-minus-square"></i>
                                                                                </button>
                                                                            </div>
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'kodeunix' + (counterPelatihan + 1)"
                                                                                :name="'kodeunix' + (counterPelatihan + 1)"
                                                                                placeholder="Kode Rapat"
                                                                                :value="Pelatihansetuju.kodeunix"
                                                                                style="width: 150px !important;">
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <input type="date"
                                                                                class="form-control form-control-sm"
                                                                                :id="'tanggal_mulai' + (counterPelatihan + 1)"
                                                                                :name="'tanggal_mulai' + (counterPelatihan + 1)"
                                                                                placeholder="Tanggal Rapat"
                                                                                :value="Pelatihansetuju.tanggal_mulai"
                                                                                style="width: 150px !important;">
                                                                            s/d<br>
                                                                            <input type="date"
                                                                                class="form-control form-control-sm"
                                                                                :id="'tanggal_selesai' + (counterPelatihan + 1)"
                                                                                :name="'tanggal_selesai' + (counterPelatihan + 1)"
                                                                                placeholder="Tanggal Rapat"
                                                                                :value="Pelatihansetuju.tanggal_selesai"
                                                                                style="width: 150px !important;">
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <input type="text"
                                                                                class="form-control form-control-sm"
                                                                                :id="'nama' + (counterPelatihan + 1)"
                                                                                :name="'nama' + (counterPelatihan + 1)"
                                                                                placeholder="Nama Pelatihan"
                                                                                :value="Pelatihansetuju.nama"
                                                                                style="width: 210px !important;">
                                                                            <br>
                                                                            <select
                                                                                class="form-control form-control-sm custom-select"
                                                                                @change="cekisi('kota1' + (counterPelatihan + 1))"
                                                                                :id="'kota1' + (counterPelatihan + 1)">
                                                                                <template
                                                                                    v-for="(datapilihannya, urutpilihannya) in lokasi"
                                                                                    :key="urutpilihannya">
                                                                                    <option :value="datapilihannya.tag"
                                                                                        :selected="datapilihannya.tag == Pelatihansetuju.kota1">
                                                                                        {{
                                                                                            datapilihannya.label
                                                                                        }}
                                                                                    </option>
                                                                                </template>
                                                                            </select>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <a :href="pdfnyafilenya_undangan_rapat_1 + Pelatihansetuju.filenya_undangan_rapat_1"
                                                                                target="_blank"
                                                                                v-if="Pelatihansetuju.filenya_undangan_rapat_1 != '' && Pelatihansetuju.filenya_undangan_rapat_1 != null">Lihat
                                                                                Dokumen</a>
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_undangan_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'filenya_undangan_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="Dokument" readonly
                                                                                :value="(Pelatihansetuju.filenya_undangan_rapat_1)">
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_undangan_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'fileToUploadfilenya_undangan_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf">
                                                                            <br>
                                                                            <div class="progress">
                                                                                <div class="progress-bar"
                                                                                    role="progressbar" aria-valuenow="0"
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100" style="width:0%"
                                                                                    :id="'persennyafilenya_undangan_rapat_1' + (counterPelatihan + 1)">
                                                                                    <span
                                                                                        :id="'tulisanpersenfilenya_undangan_rapat_1' + (counterPelatihan + 1)">0%</span>
                                                                                </div>
                                                                            </div>
                                                                            <br>
                                                                            <span class="text-success"
                                                                                :id="'suksesnyafilenya_undangan_rapat_1' + (counterPelatihan + 1)"></span>
                                                                            <br>
                                                                            <button type="button"
                                                                                class="btn btn-warning btn-sm lebar text-white"
                                                                                @click="uploadfiledetail('filenya_undangan_rapat_1' + (counterPelatihan + 1), 'application/pdf', 'filenya_undangan_rapat_1')">Upload
                                                                                File</button>
                                                                            <button type="button"
                                                                                class="btn btn-danger btn-sm lebar"
                                                                                @click="clearfilepetadetail('filenya_undangan_rapat_1' + (counterPelatihan + 1), 'filenya_undangan_rapat_1')">Hapus
                                                                                File</button>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <a :href="pdfnyafilenya_notulensi_rapat_1 + Pelatihansetuju.filenya_notulensi_rapat_1"
                                                                                target="_blank"
                                                                                v-if="Pelatihansetuju.filenya_notulensi_rapat_1 != '' && Pelatihansetuju.filenya_notulensi_rapat_1 != null">Lihat
                                                                                Dokumen</a>
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_notulensi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'filenya_notulensi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="Dokument" readonly
                                                                                :value="(Pelatihansetuju.filenya_notulensi_rapat_1)">
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_notulensi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'fileToUploadfilenya_notulensi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf">
                                                                            <br>
                                                                            <div class="progress">
                                                                                <div class="progress-bar"
                                                                                    role="progressbar" aria-valuenow="0"
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100" style="width:0%"
                                                                                    :id="'persennyafilenya_notulensi_rapat_1' + (counterPelatihan + 1)">
                                                                                    <span
                                                                                        :id="'tulisanpersenfilenya_notulensi_rapat_1' + (counterPelatihan + 1)">0%</span>
                                                                                </div>
                                                                            </div>
                                                                            <br>
                                                                            <span class="text-success"
                                                                                :id="'suksesnyafilenya_notulensi_rapat_1' + (counterPelatihan + 1)"></span>
                                                                            <br>
                                                                            <button type="button"
                                                                                class="btn btn-warning btn-sm lebar text-white"
                                                                                @click="uploadfiledetail('filenya_notulensi_rapat_1' + (counterPelatihan + 1), 'application/pdf', 'filenya_notulensi_rapat_1')">Upload
                                                                                File</button>
                                                                            <button type="button"
                                                                                class="btn btn-danger btn-sm lebar"
                                                                                @click="clearfilepetadetail('filenya_notulensi_rapat_1' + (counterPelatihan + 1), 'filenya_notulensi_rapat_1')">Hapus
                                                                                File</button>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <a :href="pdfnyafilenya_dokumentasi_rapat_1 + Pelatihansetuju.filenya_dokumentasi_rapat_1"
                                                                                target="_blank"
                                                                                v-if="Pelatihansetuju.filenya_dokumentasi_rapat_1 != '' && Pelatihansetuju.filenya_dokumentasi_rapat_1 != null">Lihat
                                                                                Dokumen</a>
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_dokumentasi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'filenya_dokumentasi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="Dokument" readonly
                                                                                :value="(Pelatihansetuju.filenya_dokumentasi_rapat_1)">
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_dokumentasi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'fileToUploadfilenya_dokumentasi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf">
                                                                            <br>
                                                                            <div class="progress">
                                                                                <div class="progress-bar"
                                                                                    role="progressbar" aria-valuenow="0"
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100" style="width:0%"
                                                                                    :id="'persennyafilenya_dokumentasi_rapat_1' + (counterPelatihan + 1)">
                                                                                    <span
                                                                                        :id="'tulisanpersenfilenya_dokumentasi_rapat_1' + (counterPelatihan + 1)">0%</span>
                                                                                </div>
                                                                            </div>
                                                                            <br>
                                                                            <span class="text-success"
                                                                                :id="'suksesnyafilenya_dokumentasi_rapat_1' + (counterPelatihan + 1)"></span>
                                                                            <br>
                                                                            <button type="button"
                                                                                class="btn btn-warning btn-sm lebar text-white"
                                                                                @click="uploadfiledetail('filenya_dokumentasi_rapat_1' + (counterPelatihan + 1), 'application/pdf', 'filenya_dokumentasi_rapat_1')">Upload
                                                                                File</button>
                                                                            <button type="button"
                                                                                class="btn btn-danger btn-sm lebar"
                                                                                @click="clearfilepetadetail('filenya_dokumentasi_rapat_1' + (counterPelatihan + 1), 'filenya_dokumentasi_rapat_1')">Hapus
                                                                                File</button>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <a :href="pdfnyafilenya_absensi_rapat_1 + Pelatihansetuju.filenya_absensi_rapat_1"
                                                                                target="_blank"
                                                                                v-if="Pelatihansetuju.filenya_absensi_rapat_1 != '' && Pelatihansetuju.filenya_absensi_rapat_1 != null">Lihat
                                                                                Dokumen</a>
                                                                            <input type="hidden"
                                                                                class="form-control form-control-sm"
                                                                                :id="'filenya_absensi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'filenya_absensi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="Dokument" readonly
                                                                                :value="(Pelatihansetuju.filenya_absensi_rapat_1)">
                                                                            <input type="file"
                                                                                class="form-control form-control-sm"
                                                                                :id="'fileToUploadfilenya_absensi_rapat_1' + (counterPelatihan + 1)"
                                                                                :name="'fileToUploadfilenya_absensi_rapat_1' + (counterPelatihan + 1)"
                                                                                placeholder="fileToUpload"
                                                                                style="font-size: smaller;"
                                                                                accept="application/pdf">
                                                                            <br>
                                                                            <div class="progress">
                                                                                <div class="progress-bar"
                                                                                    role="progressbar" aria-valuenow="0"
                                                                                    aria-valuemin="0"
                                                                                    aria-valuemax="100" style="width:0%"
                                                                                    :id="'persennyafilenya_absensi_rapat_1' + (counterPelatihan + 1)">
                                                                                    <span
                                                                                        :id="'tulisanpersenfilenya_absensi_rapat_1' + (counterPelatihan + 1)">0%</span>
                                                                                </div>
                                                                            </div>
                                                                            <br>
                                                                            <span class="text-success"
                                                                                :id="'suksesnyafilenya_absensi_rapat_1' + (counterPelatihan + 1)"></span>
                                                                            <br>
                                                                            <button type="button"
                                                                                class="btn btn-warning btn-sm lebar text-white"
                                                                                @click="uploadfiledetail('filenya_absensi_rapat_1' + (counterPelatihan + 1), 'application/pdf', 'filenya_absensi_rapat_1')">Upload
                                                                                File</button>
                                                                            <button type="button"
                                                                                class="btn btn-danger btn-sm lebar"
                                                                                @click="clearfilepetadetail('filenya_absensi_rapat_1' + (counterPelatihan + 1), 'filenya_absensi_rapat_1')">Hapus
                                                                                File</button>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <button type="button" style="width: 100px;"
                                                                                class="btn btn-info btn-sm text-white"
                                                                                @click="prosesdatapdo(Pelatihansetuju.kodeunix, Pelatihansetuju.kode)"
                                                                                data-toggle="tooltip"
                                                                                data-placement="left"
                                                                                title="Peserta data.."><i
                                                                                    class="fas fa-balance-scale"></i>
                                                                                Peserta Pelatihan
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-success3 float-left text-white lebar2"
                                        @click="simpan()" data-toggle="tooltip" data-placement="left"
                                        title="Simpan data.."><i class="fas fa-plus-square"></i>
                                        Simpan</button>
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Tutup</button>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import xlsx from 'xlsx/dist/xlsx.full.min';
import readXlsxFile from 'read-excel-file';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            jumlahminggu: '',
            datatahun: [],
            datamaster: [],
            ekportexcel: [],
            tempexcel: [],
            tempheader: [],
            tempdata: [],
            jumlahdata: 0,
            validasi: false,
            datapesan: '',
            idnya: '',
            no_sk: '',
            tanggal_sk: '',
            filenya_lampiran_sk: '',
            pdfnyafilenya_lampiran_sk: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-PDF?f=',
            filenya_lampiran_apbd: '',
            pdfnyafilenya_lampiran_apbd: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-APDB?f=',
            anggaran_apbd: 0,
            rencana_program: 0,
            filenya_lampiran_program: '',
            pdfnyafilenya_lampiran_program: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3-Program?f=',
            tanggal_rapat_1: '',
            tanggal_rapat_2: '',
            tanggal_rapat_3: '',
            tanggal_rapat_4: '',
            filenya_undangan_rapat_1: '',
            pdfnyafilenya_undangan_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan1-PDF?f=',
            filenya_undangan_rapat_2: '',
            pdfnyafilenya_undangan_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan2-PDF?f=',
            filenya_undangan_rapat_3: '',
            pdfnyafilenya_undangan_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan3-PDF?f=',
            filenya_undangan_rapat_4: '',
            pdfnyafilenya_undangan_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3undangan4-PDF?f=',
            filenya_notulensi_rapat_1: '',
            pdfnyafilenya_notulensi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi1-PDF?f=',
            filenya_notulensi_rapat_2: '',
            pdfnyafilenya_notulensi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi2-PDF?f=',
            filenya_notulensi_rapat_3: '',
            pdfnyafilenya_notulensi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi3-PDF?f=',
            filenya_notulensi_rapat_4: '',
            pdfnyafilenya_notulensi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3notulensi4-PDF?f=',
            filenya_dokumentasi_rapat_1: '',
            pdfnyafilenya_dokumentasi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi1-PDF?f=',
            filenya_dokumentasi_rapat_2: '',
            pdfnyafilenya_dokumentasi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi2-PDF?f=',
            filenya_dokumentasi_rapat_3: '',
            pdfnyafilenya_dokumentasi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi3-PDF?f=',
            filenya_dokumentasi_rapat_4: '',
            pdfnyafilenya_dokumentasi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3dokumentasi4-PDF?f=',

            filenya_absensi_rapat_1: '',
            pdfnyafilenya_absensi_rapat_1: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi1-PDF?f=',
            filenya_absensi_rapat_2: '',
            pdfnyafilenya_absensi_rapat_2: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi2-PDF?f=',
            filenya_absensi_rapat_3: '',
            pdfnyafilenya_absensi_rapat_3: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi3-PDF?f=',
            filenya_absensi_rapat_4: '',
            pdfnyafilenya_absensi_rapat_4: process.env.VUE_APP_URL_API + 'parastapainnovation_lampiranpdo3absensi4-PDF?f=',
            tahunmulai: [],
            datatahunmulai: [],
            defaultSelectedtahunmulai: {
                code: 0,
                label: 'Pilih Data',
                tag: '',
            },
            selectedtahunmulai: '',
            tahun: new Date().getFullYear(),
            lokasi: [],
            datalokasi: [],
            defaultSelectedlokasi: {
                code: 0,
                label: 'Pilih Lokasi',
                tag: '',
            },
            selectedlokasi: '',
            kota1: '',
            kota2: '',
            kota3: '',
            kota4: '',
            counterPelatihan: 0,
            Pelatihan: [
                {
                    previousPelatihan: '',
                    expirationPelatihan: ''
                }
            ],
            project_id: process.env.VUE_APP_PROJECT_ID,
            kodeunix: '',
            kodekegiatan: '',

            counterPeserta: 0,
            Peserta: [
                {
                    previousPeserta: '',
                    expirationPeserta: ''
                }
            ],
        }
    },
    methods: {
        async uploadsavedata() {
            //alert(JSON.stringify(this.tempheader));
            //alert(JSON.stringify(this.tempdata));
            var tempheader = this.tempheader;
            //console.log(JSON.stringify(this.tempdata));
            //alert(this.tempdata.length);
            //return false;
            var temparraydata = ''
            for (let i = 0; i < this.tempdata.length; i++) {
                var data = "";
                for (let x = 0; x < this.tempdata[i].length; x++) {
                    if (x == 0) {
                        data = this.tempdata[i][x];
                    }
                    else {
                        data = data + '|' + this.tempdata[i][x];
                    }
                }
                if (i == 0) {
                    temparraydata = temparraydata + data;
                }
                else {
                    temparraydata = temparraydata + '|+|' + data;
                }
            }
            //console.log(JSON.stringify(tempheader));
            //console.log(temparraydata);
            //return false;

            var fd = new FormData();
            fd.append("tempheader", tempheader);
            fd.append("data", temparraydata);
            fd.append("project_id", this.project_id);
            fd.append("kodeunix", this.kodeunix);
            fd.append("kode", this.kodekegiatan);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            this.halamanloading = true;
            //var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            await mainAPI.post("parastapainnovation_excelPDO11-SavePDO11Excel", fd).then(
                Response => {
                    if (Response.data.response == 'error') {
                        this.halamanloading = false;
                        swal.fire('Peringatan', Response.data.message, 'error');
                        $('.swal2-container').css("z-index", '999999');
                    }
                    else {
                        this.halamanloading = false;
                        swal.fire('Informasi', 'Data telah diimport..', 'success').then(function () {
                            //window.location.reload();
                            $('#costumModalpeta').modal('hide');
                        });
                        $('.swal2-container').css("z-index", '999999');

                    }
                }
            ).catch(function (error) {
                //this.halamanloading = false;
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

        },
        onChange(event) {
            this.tempjumlahdb = 0;
            try {
                if (event.target.files[0]['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    this.file = event.target.files ? event.target.files[0] : null;
                    if (this.file) {
                        this.tempheader = [];
                        this.tempdata = [];
                        readXlsxFile(this.file).then((rows) => {
                            // `rows` is an array of rows
                            // each row being an array of cells.
                            //alert(rows.length);
                            this.halamanloading = true;
                            this.tempjumlah = rows.length - 1;
                            //alert(this.tempjumlah);
                            for (let i = 0; i < rows.length; i++) {
                                this.halamanloading = true;
                                if (i == 0) {
                                    var varheader = rows[i];
                                    for (let x = 0; x < varheader.length; x++) {
                                        this.tempheader.push(varheader[x]);
                                    }
                                }
                                else {
                                    this.tempdata.push(rows[i]);
                                }
                                document.getElementById('persennyafilenya_excel').style.width = Math.round((i / (rows.length - 1)) * 100) + "%";
                                document.getElementById('tulisanpersenfilenya_excel').innerHTML = Math.round((i / (rows.length - 1)) * 100) + "%";
                            }
                            //alert(JSON.stringify(this.tempheader));
                            //console.log(this.tempdata);
                            this.halamanloading = false;
                        })
                    }
                }
                else {
                    swal.fire('Peringatan', 'File tidak sesuai format', 'error');
                    return false;
                }
            } catch (error) {

            }
        },
        addPelatihan() {
            const d = new Date();
            const year = d.getFullYear();
            // Bulan dimulai dari 0-11, jadi +1
            const month = ("0" + (d.getMonth() + 1)).slice(-2);
            const day = ("0" + d.getDate()).slice(-2);
            const hours = ("0" + d.getHours()).slice(-2);
            const minutes = ("0" + d.getMinutes()).slice(-2);
            const seconds = ("0" + d.getSeconds()).slice(-2);
            const formattedDate = `${year}${month}${day}${hours}${minutes}${seconds}` + JSON.parse(localStorage.getItem("isistem"));
            this.Pelatihan.push({
                kodeunix: formattedDate,
                previousPelatihan: '',
                expirationPelatihan: ''
            })
        },
        deletePelatihan(counterPelatihan) {
            this.Pelatihan.splice(counterPelatihan, 1);
        },
        addPeserta() {
            const d = new Date();
            const year = d.getFullYear();
            // Bulan dimulai dari 0-11, jadi +1
            const month = ("0" + (d.getMonth() + 1)).slice(-2);
            const day = ("0" + d.getDate()).slice(-2);
            const hours = ("0" + d.getHours()).slice(-2);
            const minutes = ("0" + d.getMinutes()).slice(-2);
            const seconds = ("0" + d.getSeconds()).slice(-2);
            const formattedDate = `${year}${month}${day}${hours}${minutes}${seconds}` + JSON.parse(localStorage.getItem("isistem"));
            this.Peserta.push({
                kodeunix: formattedDate,
                previousPeserta: '',
                expirationPeserta: ''
            })
        },
        deletePeserta(counterPeserta) {
            this.Peserta.splice(counterPeserta, 1);
        },
        cekisi(isinya) {
            //alert(document.getElementById(isinya).value);
        },
        async prosesdatapdo(kode, kodekegiatan) {
            //alert(kode);
            this.kodeunix = kode;
            this.kodekegiatan = kodekegiatan;
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(terpilih);
            await mainAPI.get("parastapainnovation_pesertapdo11-GetPesertaPDO11?random=" + random + "&project_id=" + this.project_id + "&kode=" + kodekegiatan + "&kodeunix=" + this.kodeunix).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.Peserta = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.Peserta = Response.data.content.data;
                        this.halamanloading = false;
                        $('#costumModalpeta').modal('show');
                    }
                    else {
                        this.Peserta = [];
                        this.halamanloading = false;
                        $('#costumModalpeta').modal('show');
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

        },
        async G_tableCSV(namefile) {
            this.ekportexcel = [];
            this.halamanloading = true;
            for (let i = 0; i < 10; i++) {
                this.ekportexcel.push({
                    "No": i + 1,
                    "Nama": "Nama Peserta " + (i + 1),
                    "Jenis Kelamin": "L/P ",
                    "Email": "Email Peserta " + (i + 1),
                    "Instansi": "Instansi Peserta " + (i + 1),
                    "Nomor Telp": "Nomor Telp Peserta " + (i + 1),
                    "Pengetahuan Meningkat": "Ya/Tidak ",
                    "Skor Pre Test": 0,
                    "Skor Post Test": 0,
                });
            }
            function formatColumn(worksheet, col, fmt) {
                const range = XLSX.utils.decode_range(worksheet['!ref'])
                // note: range.s.r + 1 skips the header row
                for (let row = range.s.r + 1; row <= range.e.r; ++row) {
                    const ref = XLSX.utils.encode_cell({ r: row, c: col })
                    if (worksheet[ref] && worksheet[ref].t === 'n') {
                        worksheet[ref].z = fmt
                    }
                }
            }
            const currency = '0.00';
            const XLSX = xlsx;
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(this.ekportexcel);

            // ARRAY NUMBER SILAHKAN MASUKKAN NOMOR KOLOM
            for (let col of [0, 7, 8]) {
                formatColumn(worksheet, col, currency)
            }
            XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
            XLSX.writeFile(workbook, this.G_formatDate(Date(), 'd-M-Y') + namefile + ".xlsx");
            this.halamanloading = false;
        },
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        ontahunmulaiChange(a) {
            try {
                this.selectedtahunmulai = this.tahunmulai[a].tag;
            }
            catch (err) {
                return;
            }
            this.AmbilDataSingel();
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_kendala-Delete", data).then(
                        Response => {
                            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/KendalaTindakLanjut/" + bytes);
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        simpan() {
            var kodeunix = "";
            var tanggal_mulai = "";
            var tanggal_selesai = "";
            var nama = "";
            var filenya_undangan_rapat_1 = "";
            var filenya_notulensi_rapat_1 = "";
            var filenya_dokumentasi_rapat_1 = "";
            var filenya_absensi_rapat_1 = "";
            var kota1 = "";
            //alert(document.getElementById("kodeunix1").value);
            //alert(document.getElementById("kodeunix2").value);
            for (let i = 1; i <= this.Pelatihan.length; i++) {
                if (i == 1) {
                    kodeunix = kodeunix + document.getElementById("kodeunix" + i).value;
                }
                else {
                    kodeunix = kodeunix + "|" + document.getElementById("kodeunix" + i).value;
                }

                if (i == 1) {
                    if (document.getElementById("tanggal_mulai" + i).value == '' || document.getElementById("tanggal_mulai" + i).value == null || document.getElementById("tanggal_mulai" + i).value == undefined) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Mohon Isikan Data Tanggal Mulai',
                        });
                        document.getElementById("tanggal_mulai" + i).focus();
                        return false;
                    }
                    tanggal_mulai = tanggal_mulai + document.getElementById("tanggal_mulai" + i).value;
                }
                else {
                    if (document.getElementById("tanggal_mulai" + i).value == '' || document.getElementById("tanggal_mulai" + i).value == null || document.getElementById("tanggal_mulai" + i).value == undefined) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Mohon Isikan Data Tanggal Mulai',
                        });
                        document.getElementById("tanggal_mulai" + i).focus();
                        return false;
                    }
                    tanggal_mulai = tanggal_mulai + "|" + document.getElementById("tanggal_mulai" + i).value;
                }


                if (i == 1) {
                    if (document.getElementById("tanggal_selesai" + i).value == '' || document.getElementById("tanggal_selesai" + i).value == null || document.getElementById("tanggal_selesai" + i).value == undefined) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Mohon Isikan Data Tanggal Selesai',
                        });
                        document.getElementById("tanggal_selesai" + i).focus();
                        return false;
                    }
                    tanggal_selesai = tanggal_selesai + document.getElementById("tanggal_selesai" + i).value;
                }
                else {
                    if (document.getElementById("tanggal_selesai" + i).value == '' || document.getElementById("tanggal_selesai" + i).value == null || document.getElementById("tanggal_selesai" + i).value == undefined) {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: 'Mohon Isikan Data Tanggal Selesai',
                        });
                        document.getElementById("tanggal_selesai" + i).focus();
                        return false;
                    }
                    tanggal_selesai = tanggal_selesai + "|" + document.getElementById("tanggal_selesai" + i).value;
                }
                //alert(document.getElementById("nama" + i).value);
                if (i == 1) {
                    nama = nama + document.getElementById("nama" + i).value;
                    //alert(nama);
                }
                else {
                    nama = nama + "|" + document.getElementById("nama" + i).value;
                    //alert(nama);
                }

                //alert(nama);
                //return;

                var tempfilenya_undangan_rapat_1 = document.getElementById("filenya_undangan_rapat_1" + i).value;

                if (i == 1) {
                    filenya_undangan_rapat_1 = filenya_undangan_rapat_1 + tempfilenya_undangan_rapat_1;
                }
                else {
                    filenya_undangan_rapat_1 = filenya_undangan_rapat_1 + "|" + tempfilenya_undangan_rapat_1;
                }


                var tempfilenya_notulensi_rapat_1 = document.getElementById("filenya_notulensi_rapat_1" + i).value;
                
                if (i == 1) {
                    filenya_notulensi_rapat_1 = filenya_notulensi_rapat_1 + tempfilenya_notulensi_rapat_1;
                }
                else {
                    filenya_notulensi_rapat_1 = filenya_notulensi_rapat_1 + "|" + tempfilenya_notulensi_rapat_1;
                }


                var tempfilenya_dokumentasi_rapat_1 = document.getElementById("filenya_dokumentasi_rapat_1" + i).value;
                
                if (i == 1) {
                    filenya_dokumentasi_rapat_1 = filenya_dokumentasi_rapat_1 + tempfilenya_dokumentasi_rapat_1;
                }
                else {
                    filenya_dokumentasi_rapat_1 = filenya_dokumentasi_rapat_1 + "|" + tempfilenya_dokumentasi_rapat_1;
                }


                var tempfilenya_absensi_rapat_1 = document.getElementById("filenya_absensi_rapat_1" + i).value;
                if (i == 1) {
                    filenya_absensi_rapat_1 = filenya_absensi_rapat_1 + tempfilenya_absensi_rapat_1;
                }
                else {
                    filenya_absensi_rapat_1 = filenya_absensi_rapat_1 + "|" + tempfilenya_absensi_rapat_1;
                }

                if (i == 1) {
                    kota1 = kota1 + document.getElementById("kota1" + i).value;
                }
                else {
                    kota1 = kota1 + "|" + document.getElementById("kota1" + i).value;
                }
            }

            //alert(kodeunix);
            //return;
            var fd = new FormData();

            fd.append("kode", this.idnya);
            fd.append("kodeunix", kodeunix);
            fd.append("tanggal_mulai", tanggal_mulai);
            fd.append("tanggal_selesai", tanggal_selesai);
            fd.append("nama", nama);
            fd.append("filenya_undangan_rapat_1", filenya_undangan_rapat_1);
            fd.append("filenya_notulensi_rapat_1", filenya_notulensi_rapat_1);
            fd.append("filenya_dokumentasi_rapat_1", filenya_dokumentasi_rapat_1);
            fd.append("filenya_absensi_rapat_1", filenya_absensi_rapat_1);
            fd.append("kota1", kota1);
            fd.append("project_id", this.project_id);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_pdo11-UpdatePDO11", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/Monev/" + bytes);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            var kode = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Monev/" + kode);
        },
        uploadfiledetail(idnya, tipenya, filenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", filenya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                        try {
                            document.getElementById('tempsuksesnya' + idnya).innerHTML = res.data.filename;
                        } catch (error) {

                        }

                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                try {
                    document.getElementById('tempsuksesnya' + idnya).innerHTML = '';
                } catch (error) {

                }

                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepetadetail(idnya, filenya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", filenya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    $('.swal2-container').css("z-index", '999999');
                    document.getElementById(idnya).value == '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
                $('.swal2-container').css("z-index", '999999');
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            try {
                document.getElementById('tempsuksesnya' + idnya).innerHTML = '';
            } catch (error) {

            }
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            if (this.selectedtahunmulai == '') {
                this.selectedtahunmulai = this.tahun;
            }
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });


            await mainAPI5.get("parastapainnovationreffmonitoring-Lokasi?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datalokasi = [];
                        this.lokasi = [];
                        this.datalokasi = Response.data.content.data;
                        this.datalokasi.forEach((item) => {
                            this.lokasi.push({
                                label: item.nama,
                                code: this.datalokasi.indexOf(item) + 1,
                                tag: item.id,
                            });
                        });
                        this.lokasi.unshift({
                            label: 'Pilih Lokasi',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });

            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            var tmp = this.secretencData.split("_");
            var terpilih = tmp[0];
            this.idnya = tmp[0];
            //alert(terpilih);
            await mainAPI.get("parastapainnovation_pdo11-GetDataPDO11?random=" + random + "&project_id=" + this.project_id + "&kode=" + terpilih + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.Nama_Kegiatan = '';
                    this.Pelatihan = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.Pelatihan = Response.data.content.data;
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.halamanloading = false;
                    }
                    else {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.Pelatihan = [];
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        validasidata() {
            if (document.getElementById('tanggal').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('tanggal').focus();
                return false;
            }
            if (document.getElementById('target_penyelesaian').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('target_penyelesaian').focus();
                return false;
            }
            if (this.kendala == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Kendala',
                });
                return false;
            }
            if (this.tindaklanjut == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Tindak Lanjut',
                });
                return false;
            }
            if (this.penanggungjawab == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Penanggungjawab',
                });
                return false;
            }
            if (document.getElementById('filenya_kendala').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Foto',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.AmbilDataSingel();
    }
}
</script>
<style></style>